import { Box, Button, Flex, FormControl, FormLabel, Switch } from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";
import MonthCalendar from "components/Calendar/MonthCalendar";
import { CalendarEvent } from "components/Calendar/types";
import type { PreviewAction } from "../types";
import { previewActionsToCalendarEvents } from "../helpers";

interface PreviewMonthViewProps {
  actions: PreviewAction[];
  startDate: string;
  timezone: string;
  onEventClick?: (event: CalendarEvent) => void;
}

export default function PreviewMonthView({ actions, startDate, timezone, onEventClick }: PreviewMonthViewProps) {
  const [visibleMonth, setVisibleMonth] = useState(() => moment.tz(startDate, timezone).startOf("month"));
  const [showWeekends, setShowWeekends] = useState(false);

  const events = previewActionsToCalendarEvents(actions, timezone);

  return (
    <Flex direction="column" width="100%">
      <Flex justify="space-between" align="center" px="4" py="2">
        <FormControl display="flex" alignItems="center" width="auto">
          <FormLabel htmlFor="preview-weekends-month" mb="0" fontSize="sm">
            Show weekends
          </FormLabel>
          <Switch
            id="preview-weekends-month"
            isChecked={showWeekends}
            onChange={(e) => setShowWeekends(e.target.checked)}
          />
        </FormControl>
        <Box fontWeight="bold" fontSize="lg">
          {visibleMonth.format("MMMM YYYY")}
        </Box>
        <Flex gap="2">
          <Button
            size="sm"
            variant="outline"
            onClick={() => setVisibleMonth(visibleMonth.clone().subtract(1, "month"))}
          >
            ← Prev
          </Button>
          <Button
            size="sm"
            variant="outline"
            onClick={() => setVisibleMonth(moment.tz(startDate, timezone).startOf("month"))}
          >
            Start Day
          </Button>
          <Button size="sm" variant="outline" onClick={() => setVisibleMonth(visibleMonth.clone().add(1, "month"))}>
            Next →
          </Button>
        </Flex>
      </Flex>
      <MonthCalendar
        visibleMonth={visibleMonth}
        events={events}
        timezone={timezone}
        showWeekends={showWeekends}
        handleClick={onEventClick || (() => {})}
      />
    </Flex>
  );
}
